export default {
  fields: {
    export_run_id: { type: 'string' },
    file_type: { type: 'string' },
    start_date: { type: 'date' },
    end_date: { type: 'date' },
    user_id: { type: 'number' },
    creator_email: { type: 'string' },
    created_at: { type: 'date' },
    download_url: { type: 'string' },
  },
}
